export default __webpack_public_path__ + "static/media/Join Membership.102cc44f.png";